import {
  DisplayRecommendation,
  type PricePartsFragment,
} from 'src/App/generated/graphql-types';
import type { PriceItem } from './AdPriceDetails';

export const mapPrice = (price: PricePartsFragment): PriceItem => {
  const { netPrice, retailPrice, discount, tax, retailTax } = price;

  const taxInfo = tax
    ? {
        code: tax.code,
        displayRecommendation:
          tax.displayRecommendation ?? DisplayRecommendation.INCLUSIVE,
        amount: tax.amount ?? {
          value: 0,
          currency: netPrice.currency,
        },
      }
    : undefined;

  const retailTaxInfo =
    retailTax?.code && retailTax?.displayRecommendation && retailTax?.amount
      ? {
          code: retailTax.code,
          displayRecommendation: retailTax.displayRecommendation,
          amount: retailTax.amount,
        }
      : undefined;

  return {
    netPrice,
    retailPrice,
    discount: discount ?? { discountPercentage: 0 },
    tax: taxInfo,
    retailTax: retailTaxInfo,
  };
};
